import {
  SPRING_CALC_RECEIVE,
  SPRING_CALC_RECEIVE_CALCULATED_VALUES,
  SPRING_CALC_TOGGLE_BUTTON_STATUS,
  SPRING_CALC_LOAD_ERROR,
  SPRING_CALC_SHOW_INFO,
  SPRING_CALC_ADDING_MANY,
  SPRING_CALC_TOGGLE_SHOW,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  showSpringCalculator: false,
  data: null,
  calculatedValues: null,
  showInfo: false,
  buttonEnabled: false,
  errors: {},
};

export const springCalc = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SPRING_CALC_RECEIVE:
    case SPRING_CALC_RECEIVE_CALCULATED_VALUES:
    case SPRING_CALC_TOGGLE_BUTTON_STATUS:
    case SPRING_CALC_SHOW_INFO:
    case SPRING_CALC_ADDING_MANY:
    case SPRING_CALC_TOGGLE_SHOW:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case SPRING_CALC_LOAD_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
